export type ControlDensity = "default" | "sm" | "compact";

export const CONTROL_DENSITIES = ["default", "sm", "compact"] as const;

export const CONTROL_HEIGHT_CLASSES: Record<ControlDensity, string> = {
  default: "h-control",
  sm: "h-control-sm",
  compact: "h-control-compact",
};

export const CONTROL_SQUARE_CLASSES: Record<ControlDensity, string> = {
  default: "size-control",
  sm: "size-control-sm",
  compact: "size-control-compact",
};

export const CONTROL_DENSE_SQUARE_CLASS =
  "size-control-dense min-h-control-dense";
